/** Google's favicon service resolves a host to its icon without loading the
 *  site itself, so a table of customer websites never hits those hosts from
 *  the viewer's browser. The URL-field glyph reads the 32px source (it
 *  renders at 16px); larger plates ask for a source at twice their
 *  rendered size — the 64px account logo tile reads 128. */
export function faviconSrc(host: string, size: 32 | 64 | 128 = 32): string {
  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=${size}`;
}
